import { assertAdminDataWriteAccess } from "../projects-helpers.js";
export function createIntercomQueries({ defineProjectQuery, projectZql, }) {
    return {
        intercomChannels: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.projectIntercomChannels.where("id", "__unauthorized__");
                }
                return projectZql.projectIntercomChannels
                    .where("projectID", args.projectID)
                    .orderBy("sortOrder", "asc");
            }),
        },
        intercomAssignments: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.projectIntercomAssignments.where("id", "__unauthorized__");
                }
                return projectZql.projectIntercomAssignments
                    .where("projectID", args.projectID)
                    .related("person")
                    .related("profile");
            }),
        },
        intercomProfiles: {
            byProject: defineProjectQuery(({ args, ctx, }) => {
                if (ctx.role !== "admin" && ctx.role !== "employee") {
                    return projectZql.projectIntercomProfiles.where("id", "__unauthorized__");
                }
                return projectZql.projectIntercomProfiles.where("projectID", args.projectID);
            }),
        },
    };
}
export function createIntercomMutators({ defineProjectMutator, schemas, }) {
    const { createIntercomChannelInputSchema, updateIntercomChannelInputSchema, intercomChannelIDInputSchema, createIntercomAssignmentInputSchema, updateIntercomAssignmentInputSchema, intercomAssignmentIDInputSchema, createIntercomProfileInputSchema, updateIntercomProfileInputSchema, intercomProfileIDInputSchema, bulkAssignIntercomProfileInputSchema, } = schemas;
    return {
        intercomChannels: {
            create: defineProjectMutator(createIntercomChannelInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomChannels.insert({
                    id: args.id,
                    projectID: args.projectID,
                    name: args.name,
                    description: args.description ?? null,
                    channelNumber: args.channelNumber ?? null,
                    sortOrder: args.sortOrder ?? 0,
                });
            }),
            update: defineProjectMutator(updateIntercomChannelInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomChannels.update(args);
            }),
            delete: defineProjectMutator(intercomChannelIDInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomChannels.delete({ id: args.id });
            }),
        },
        intercomAssignments: {
            create: defineProjectMutator(createIntercomAssignmentInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomAssignments.insert({
                    id: args.id,
                    projectID: args.projectID,
                    personID: args.personID ?? null,
                    profileID: args.profileID ?? null,
                    unityUsername: args.unityUsername ?? null,
                    displayName: args.displayName ?? null,
                });
            }),
            update: defineProjectMutator(updateIntercomAssignmentInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomAssignments.update(args);
            }),
            delete: defineProjectMutator(intercomAssignmentIDInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomAssignments.delete({ id: args.id });
            }),
            bulkAssignProfile: defineProjectMutator(bulkAssignIntercomProfileInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                for (const id of args.assignmentIDs) {
                    await tx.mutate.projectIntercomAssignments.update({
                        id,
                        profileID: args.profileID ?? null,
                    });
                }
            }),
        },
        intercomProfiles: {
            create: defineProjectMutator(createIntercomProfileInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomProfiles.insert({
                    id: args.id,
                    projectID: args.projectID,
                    name: args.name,
                    channelConfig: args.channelConfig ?? {},
                });
            }),
            update: defineProjectMutator(updateIntercomProfileInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomProfiles.update(args);
            }),
            delete: defineProjectMutator(intercomProfileIDInputSchema, async ({ tx, ctx, args, }) => {
                assertAdminDataWriteAccess(ctx);
                await tx.mutate.projectIntercomProfiles.delete({ id: args.id });
            }),
        },
    };
}
